import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const minhasTarefasRepository = createRepository({
  path: 'tarefa\\/minhas-tarefas',
  restApi,
  queryTransform: {
    descricao: query.ilike('descricao'),
    assunto: query.ilike('assunto'),
    createdAt: query.gte('createdAt'),
    dataTermino: query.gte('dataTermino'),
    ...paginate
  }
})

minhasTarefasRepository.proxima = () => {
  return restApi.get('tarefa/proxima')
}

minhasTarefasRepository.count = where => {
  return restApi.get('tarefa/count', { where })
}

minhasTarefasRepository.countPureExclusivaAnalista2 = where => {
  return restApi.get('tarefa/count-pure-exclusiva-analista2', { where })
}

export default minhasTarefasRepository
